import { createApi } from "../../../../utils/createApi";
import axios, { AxiosError, AxiosResponse } from "axios";
import { universalAPIErrorHandler } from "../../../../utils/universalAPIErrorHandler";
import { filterEmptySearchResultGroups } from "./filterEmptySearchResultGroups";

export const handleSearchBarFilter = async (
  inputValue: string, // Change parameter from event to inputValue
  setSearchBarValue: any,
  setEditedParentGroupList: any,
  navigate: any,
  setBackdropLoadingScreenOn: any,
  // ENG-2682: the search bar aborts the previous search when a new one starts,
  // so a slow earlier response can't overwrite the newer results.
  signal?: AbortSignal
) => {
  setSearchBarValue(inputValue);
  const AxiosUI = createApi(``);
  const retryFunction = () => {
    if (signal?.aborted) return;
    handleSearchBarFilter(
      inputValue,
      setSearchBarValue,
      setEditedParentGroupList,
      navigate,
      setBackdropLoadingScreenOn,
      signal
    );
  };
  const groupType = window.location.pathname.includes("patrol")
    ? "patrol"
    : "connector";

  await AxiosUI.get(
    `group/?search=${encodeURIComponent(inputValue)}&group_type=${groupType}`,
    { signal }
  ).then(
    (response: AxiosResponse) => {
      if (signal?.aborted) return;
      setBackdropLoadingScreenOn(false);
      setEditedParentGroupList(
        filterEmptySearchResultGroups(response.data.results)
      );
    },
    (reason: AxiosError) => {
      // A newer search replaced this one: nothing to show or retry.
      if (axios.isCancel(reason) || signal?.aborted) return;
      universalAPIErrorHandler(reason, navigate, retryFunction, (context) => {
        // A failed search used to leave the loading overlay up for good.
        if (!context?.willRetry) setBackdropLoadingScreenOn(false);
      });
    }
  );
};
